/** @flow */
import * as React from 'react';
import styled, { withTheme } from 'styled-components';

import Card from './Card';

const getAlignementForPosition = (position) => {
  if (position === 'left') {
    return 'flex-start';
  }

  if (position === 'right') {
    return 'flex-end';
  }

  return position;
};

const CardWrapper = styled.div`
  flex-direction: column;
  display: flex;
  cursor: pointer;
  width: 100%;
  padding: ${({ theme }) => theme.metrics.margin}px;
  position: relative;
`;

const CardContent = styled.div`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  display: flex;
  height:100%;
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => `0 5% ${theme.metrics.smallMargin}px 5%`};
`;

const CardTitle = styled.span`
  align-self: ${({ position }) => getAlignementForPosition(position)};
`;

const IconWrapper = styled.div`
  position: absolute;
  right: ${({ position }) => (position === 'right' ? '5%' : 'auto')};
  left: ${({ position }) => (position === 'left' ? '5%' : 'auto')};
  top: ${({ theme }) => `${theme.metrics.margin}px`};
  padding: ${({ theme }) => `0 ${theme.metrics.margin}px`};
`;


type Props = {
  title: string | React.Element<any>;
  children?: React.Element<any>;
  small?: boolean;
  titlePosition?: 'center' | 'left' | 'right';
  iconPosition?: 'left' | 'right';
  icon?: any;
  style?: Object,
  containerStyle?: Object,
  titleStyle?: Object,
  theme: Object;
}

function OverviewCard({ title, children, small, titlePosition, icon, iconPosition, style, containerStyle, titleStyle, theme }: Props) {
  const cardTitle = {
    ...(small ? theme.fonts.style.smallCardTitle : theme.fonts.style.cardTitle),
    ...titleStyle,
  };
  return (
    <Card style={containerStyle}>
      <CardWrapper style={style}>
        <CardHeader>
          <CardTitle position={titlePosition} style={cardTitle}>{title}</CardTitle>
        </CardHeader>
        <IconWrapper position={iconPosition}>{icon}</IconWrapper>
        <CardContent>
          {children}
        </CardContent>
      </CardWrapper>
    </Card>
  );
}

export default withTheme(OverviewCard);



// WEBPACK FOOTER //
// ./src/common/components/OverviewCard.js